import React, { useEffect } from 'react'
import modalController from 'src/decorators/ModalController'
import PreviewUISync from 'src/containers/PreviewUISync'

const stepModalMap: {
  newsletterSignup: string
  marketingPopup: string
} = {
  newsletterSignup: 'NewsletterSignupModal',
  marketingPopup: 'MarketingPopupModal'
}

interface OnSectionSettingStepChange {
  fromStep?: {
    id?: string
  }
  toStep?: {
    id?: string
  }
}

interface PreviewModeUISyncProps {
  previewMode: boolean
  sectionId: string
  settings: {
    popupFrequency: string
    enableMarketingPopup: boolean
    triggerType: string
    timeDelayTrigger: number
    pageScrollTrigger: number
    enableNewsletterSignup: boolean
  }
  toggleMarketingPopupTrigger: (param: { triggerEnabled: boolean }) => void
}

const PreviewModeUISync = ({
  previewMode,
  sectionId,
  settings,
  toggleMarketingPopupTrigger
}: PreviewModeUISyncProps): JSX.Element => {
  useEffect(() => {
    const isNewsletterSignupModalOpen = modalController.isOpen(
      'NewsletterSignupModal'
    )

    if (previewMode) {
      if (settings.enableMarketingPopup) {
        modalController.showModal('MarketingPopupModal')
      } else {
        if (isNewsletterSignupModalOpen) {
          modalController.closeModal('NewsletterSignupModal')
        } else {
          modalController.closeModal('MarketingPopupModal')
        }
      }
    }

    if (previewMode) {
      if (isNewsletterSignupModalOpen && !settings.enableNewsletterSignup) {
        modalController.closeModal('NewsletterSignupModal')
      } else if (
        !isNewsletterSignupModalOpen &&
        settings.enableNewsletterSignup
      ) {
        // NOTE: Don't need to check if MarketingPopupModal is opened here,
        // since the current behaviour guarantee that MarketingPopupModal is never opened when customisation UI is showing Newsletter signup sidebar.
        // and merchant can only toggle enableNewsletterSignup when inside the Newsletter Signup sidebar
        modalController.showModal('NewsletterSignupModal')
      }
    }
  }, [
    settings.enableMarketingPopup,
    settings.enableNewsletterSignup,
    previewMode
  ])

  const onSectionSettingStepChange = ({
    fromStep = {},
    toStep = {}
  }: OnSectionSettingStepChange = {}) => {
    const fromModal = stepModalMap[fromStep.id]
    const toModal = stepModalMap[toStep.id]
    // NOTE: When customisation UI sidebar is showing Newsletter Signup, trigger shouldn't open MarkertingPopupmodal
    toggleMarketingPopupTrigger({
      triggerEnabled: toStep.id !== 'newsletterSignup'
    })
    if (modalController.isOpen(fromModal)) {
      modalController.closeModal(fromModal, () => {
        // NOTE: If `enableNewsletterSignup` setting is false, don't ever show NewsletterSignupModal
        if (
          !settings.enableNewsletterSignup &&
          toModal === 'NewsletterSignupModal'
        ) {
          return
        }
        modalController.showModal(toModal)
      })
    } else {
      modalController.showModal(toModal)
    }
  }

  const showMarketingPopupModal = () => {
    const { enableMarketingPopup } = settings
    const isNewsletterSignupModalOpen = modalController.isOpen(
      'NewsletterSignupModal'
    )
    const showMarketingPopupModal = () =>
      enableMarketingPopup && modalController.showModal('MarketingPopupModal')
    if (isNewsletterSignupModalOpen) {
      modalController.closeModal(
        'NewsletterSignupModal',
        showMarketingPopupModal
      )
    } else {
      showMarketingPopupModal()
    }
  }

  return (
    <PreviewUISync
      sectionId={sectionId}
      onPreviewModeScrollIntoView={showMarketingPopupModal}
      onPreviewModeChangeSectionSettingStep={onSectionSettingStepChange}
    />
  )
}

export default PreviewModeUISync
